var StepTwoInbentaBaseView, StepTwoInbentaNLPView, SupportAPIHelper, SupportMainContentWrapperView, SupportSearchInputView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

SupportSearchInputView = require('../../search_input_view');

StepTwoInbentaBaseView = require('./base_view');

SupportAPIHelper = require('../../../helpers/API');

StepTwoInbentaNLPView = (function(superClass) {
  extend(StepTwoInbentaNLPView, superClass);

  function StepTwoInbentaNLPView() {
    this.initiateInbentaEvents = bind(this.initiateInbentaEvents, this);
    this.simulatedDropdownsCb = bind(this.simulatedDropdownsCb, this);
    this.helpContentError = bind(this.helpContentError, this);
    this.setFlexStepThreeComb = bind(this.setFlexStepThreeComb, this);
    this.helpContentSuccess = bind(this.helpContentSuccess, this);
    return StepTwoInbentaNLPView.__super__.constructor.apply(this, arguments);
  }

  StepTwoInbentaNLPView.prototype.initialize = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      window.simulateDropdownSelection();
      this.initiateInbentaEvents();
    }
    StepTwoInbentaBaseView.prototype.initialize.apply(this, arguments);
    return this.searchInputView = new SupportSearchInputView();
  };

  StepTwoInbentaNLPView.prototype.fetchAndRenderCategory = function(contentWrapper) {
    if (!this.dropDownCombinationsModel.has('flexStepThree')) {
      startTimer("t_dc");
      return this.dropDownCombinationsModel.fetch({
        data: null,
        success: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_dc");
            return _this.handleDropdownsCb(contentWrapper, response);
          };
        })(this),
        error: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_dc");
            return _this.handleDropdownsCb(contentWrapper, response);
          };
        })(this)
      });
    }
  };

  StepTwoInbentaNLPView.prototype.renderInbentaSearchBox = function(contentWrapper) {
    this.searchInputView.render();
    return contentWrapper.append(this.searchInputView.el);
  };

  StepTwoInbentaNLPView.prototype.handleDropdownsCb = function(contentWrapper, response) {
    return this.setFlexStepThreeComb(response);
  };

  StepTwoInbentaNLPView.prototype.helpContentSuccess = function(results) {
    this.spinnerView.hide({
      container: $('#nlp-spinner')
    });
    if (((results != null ? results.length : void 0) != null) > 0) {
      Groupon.Support.ContentModel.flexibleStepThree = results[0];
    }
    this.flexStepThree['responseReceived'] = true;
    if (this.inbentaEventType) {
      return this.callInbentaEventCb();
    }
  };

  StepTwoInbentaNLPView.prototype.fetchDropdownCombinations = function() {
    return this.dropDownCombinationsModel.attributes;
  };

  StepTwoInbentaNLPView.prototype.setFlexStepThreeComb = function(response) {
    var ref;
    this.flexStepThree.dropdownCombinations = (ref = response.flexStepThree) != null ? ref['dropdownCombinations'] : void 0;
    return this.flexStepThree['responseReceived'] = true;
  };

  StepTwoInbentaNLPView.prototype.helpContentError = function() {
    this.spinnerView.hide({
      container: $('#nlp-spinner')
    });
    this.flexStepThree['responseReceived'] = true;
    if (this.inbentaEventType != null) {
      return this.callInbentaEventCb();
    }
  };

  StepTwoInbentaNLPView.prototype.callInbentaEventCb = function() {
    if (this.inbentaEventType === 'solved-feedback') {
      return this.step2SolvedFeedBackCb();
    } else if (this.inbentaEventType === 'step2-continue-disabled') {
      return this.step2ContinueDisabledCb();
    } else if (this.inbentaEventType === 'step2-continue-enabled') {
      return this.step2ContinueEnabledCb();
    }
  };

  StepTwoInbentaNLPView.prototype.step2SolvedFeedBackCb = function() {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = 'solved-feedback';
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(true);
    $('.direct-ticket').css('display', 'none');
    $('.issue-check').css('display', 'block');
    return $('#contact-us').attr('disabled', false);
  };

  StepTwoInbentaNLPView.prototype.step2ContinueDisabledCb = function(event) {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = 'step2-continue-disabled';
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(true);
    $('.issue-check').css('display', 'none');
    $('.direct-ticket').css('display', 'block');
    return $('#continueToTicket').attr('disabled', true);
  };

  StepTwoInbentaNLPView.prototype.step2ContinueEnabledCb = function(event) {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = 'step2-continue-enabled';
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(false);
    $('.issue-check').css('display', 'none');
    $('.direct-ticket').css('display', 'block');
    return $('#continueToTicket').attr('disabled', false);
  };

  StepTwoInbentaNLPView.prototype.fetchHelpContent = function(inbentaEventType) {
    var data, urls;
    this.inbentaEventType = inbentaEventType;
    if (this.isFlexStepThreeAllowed()) {
      this.spinnerView.show({
        container: $('#nlp-spinner')
      });
      this.resetFlexStepThree();
      urls = this.getHelpContentPaths();
      data = this.getTaglines();
      this.contentRequests = SupportAPIHelper.parallel(urls, data, this.getHelpContentSuccessCb(), this.getHelpContenteErrorCb(), false, "t_ic", 60000);
    } else {
      Groupon.Support.ContentModel.flexibleStepThree = null;
      this.callInbentaEventCb();
    }
    Groupon.Support.ContentModel.isCostcoDropdownCombination = window.isCostcoDropdownCombination();
    return this.setFlexibleContactChannels();
  };

  StepTwoInbentaNLPView.prototype.simulatedDropdownsCb = function(inbentaEventType) {
    return this.fetchHelpContent(inbentaEventType);
  };

  StepTwoInbentaNLPView.prototype.initiateInbentaEvents = function() {
    $(document).bind('step2-solved-feedback', (function(_this) {
      return function(event) {
        return _this.step2SolvedFeedBackCb(event);
      };
    })(this));
    $(document).bind('step2-continue-disabled', (function(_this) {
      return function(event) {
        return _this.step2ContinueDisabledCb(event);
      };
    })(this));
    return $(document).bind('step2-continue-enabled', (function(_this) {
      return function(event) {
        return _this.step2ContinueEnabledCb(event);
      };
    })(this));
  };

  return StepTwoInbentaNLPView;

})(StepTwoInbentaBaseView);

window.simulateDropdownSelection = function() {
  if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
    return window.InbentaHelpWizard.prototype.simulateDropdownSelection = function(targetElement) {
      var category, ref, searchText, subcategory;
      category = '';
      subcategory = '';
      $(targetElement).find('.hwcategories').each(function() {
        var currentCat, currentSubcat;
        if (!category || !subcategory) {
          currentCat = $.trim($(this).find('.hwcategory').text());
          currentSubcat = $.trim($(this).find('.hwsubcategory').text());
          category = currentCat;
          return subcategory = currentSubcat;
        }
      });
      if (!this.step2firstDropdownSelection && (!category || !subcategory)) {
        category = this.step2defaultDropdownSelection.category;
        subcategory = this.step2defaultDropdownSelection.subcategory;
      }
      if (category && subcategory) {
        Groupon.Support.Inbenta.Category = {
          text: category,
          id: this.getDropdownCategoryKeyValue(category)
        };
        Groupon.Support.Inbenta.SubCategory = {
          text: subcategory,
          id: this.getDropdownCategoryKeyValue(subcategory)
        };
        searchText = $('.inbenta-searchform-container #inbenta-searchform #inbenta-searchinput').val() || "";
        if ((searchText != null ? searchText.length : void 0) > 0) {
          searchText = searchText.trim();
        }
        if ((searchText != null ? searchText.length : void 0) === 0 && $(targetElement).hasClass('hwresult')) {
          this.step2firstDropdownSelection = false;
          Groupon.Support.StepTwoView.simulatedDropdownsCb('step2-continue-enabled');
          Groupon.Support.Inbenta.searchInputIssue = (ref = Groupon.Support.Inbenta.SubCategory) != null ? ref.text : void 0;
        } else {
          this.step2firstDropdownSelection = true;
          Groupon.Support.StepTwoView.simulatedDropdownsCb(null);
          Groupon.Support.Inbenta.searchInputIssue = searchText;
        }
      }
      return $.event.trigger('simulated-dropdowns');
    };
  }
};

module.exports = StepTwoInbentaNLPView;

//# sourceMappingURL=data:application/json;base64,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
